import { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function Svg(props: IconProps) {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 24 24"
			fill="none"
			stroke="currentColor"
			strokeWidth="2"
			strokeLinecap="round"
			strokeLinejoin="round"
			aria-hidden="true"
			{...props}
		/>
	);
}

export function IconSearch(props: IconProps) {
	return (
		<Svg {...props}>
			<circle cx="11" cy="11" r="8" />
			<path d="m21 21-4.34-4.34" />
		</Svg>
	);
}

export function IconChevron(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="m6 9 6 6 6-6" />
		</Svg>
	);
}

export function IconArrowUpRight(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="M7 7h10v10" />
			<path d="M7 17 17 7" />
		</Svg>
	);
}

export function IconArrowLeft(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="M19 12H5" />
			<path d="m12 19-7-7 7-7" />
		</Svg>
	);
}

export function IconArrowRight(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="M5 12h14" />
			<path d="m12 5 7 7-7 7" />
		</Svg>
	);
}

export function IconGithub(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4" />
			<path d="M9 18c-4.51 2-5-2-7-2" />
		</Svg>
	);
}

export function IconInstagram(props: IconProps) {
	return (
		<Svg {...props}>
			<rect width="20" height="20" x="2" y="2" rx="5" />
			<path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
			<line x1="17.5" x2="17.51" y1="6.5" y2="6.5" />
		</Svg>
	);
}

export function IconLinkedin(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
			<rect width="4" height="12" x="2" y="9" />
			<circle cx="4" cy="4" r="2" />
		</Svg>
	);
}

export function IconUnsplash(props: IconProps) {
	return (
		<Svg {...props} fill="currentColor" stroke="none">
			<path d="M7.5 6.75V0h9v6.75h-9zm9 3.75H24V24H0V10.5h7.5v6.75h9V10.5z" />
		</Svg>
	);
}

export function IconMail(props: IconProps) {
	return (
		<Svg {...props}>
			<rect width="20" height="16" x="2" y="4" rx="2" />
			<path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7" />
		</Svg>
	);
}

export function IconSun(props: IconProps) {
	return (
		<Svg {...props}>
			<circle cx="12" cy="12" r="4" />
			<path d="M12 2v2" />
			<path d="M12 20v2" />
			<path d="m4.93 4.93 1.41 1.41" />
			<path d="m17.66 17.66 1.41 1.41" />
			<path d="M2 12h2" />
			<path d="M20 12h2" />
			<path d="m6.34 17.66-1.41 1.41" />
			<path d="m19.07 4.93-1.41 1.41" />
		</Svg>
	);
}

export function IconMoon(props: IconProps) {
	return (
		<Svg {...props}>
			<path d="M12 3a6 6 0 0 0 9 9 9 9 0 1 1-9-9Z" />
		</Svg>
	);
}

export function socialIcon(id: string) {
	switch (id) {
		case "github":
			return IconGithub;
		case "instagram":
			return IconInstagram;
		case "linkedin":
			return IconLinkedin;
		case "email":
			return IconMail;
		case "unsplash":
			return IconUnsplash;
		default:
			return IconArrowUpRight;
	}
}
